export default {env:{value:'dev',label:'dev環境'},manage:{backendServerApi:{protocol:'https',hostname:'manage-api.app-point.dev.nicovideo.jp',port:443}}};